import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchPlansApi } from '~/api';
import { fetchPlans, fetchPlansSuccess, fetchPlansFailure } from '~/store/slices/plans';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';

export function* fetchPlansSaga(): Generator<any, void, any> {
  try {
    const promise = fetchPlansApi();
    const response = yield call(apiResponseHandler, promise);

    if (response.type === ApiResponseEnum.Success) {
      yield put(fetchPlansSuccess(response.data));
    } else {
      yield put(fetchPlansFailure());
    }
  } catch (error) {
    yield put(fetchPlansFailure());
  }
}

export default function* root() {
  yield all([takeLatest(fetchPlans.type, fetchPlansSaga)]);
}
